import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Observable } from 'rxjs';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { CommCenterService } from '../..';
import { Session } from '../../services/session.service';

@Component({
    selector: 'app-emulate-user-header',
    template: `
    <div>
      <mat-toolbar
        color="primary"
        class="header fixtoolbar last-head-bar"
        [class.mat-elevation-z4]="scrolled"
        style="z-index:999"
        >
        @if ((isSmall$ | async) && !this.isAuditor) {
          <button
            type="button"
            [attr.aria-label]="'Toggle sidenav' | translation: translationRequest"
            mat-icon-button
            (click)="toggleMenu()"
            >
            <mat-icon
              [attr.aria-label]="'Side nav toggle icon' | translation: translationRequest" class="app-icon"
              >menu</mat-icon
              >
            </button>
          }
          <div class="tw-flex tw-w-full md:tw-w-1/4">
            <app-logos></app-logos>
          </div>
          @if (isAuditor) {
            <div class="">{{ 'Client' | translation: translationRequest }} : {{ clientHeader }}</div>
          }
          <span class="example-spacer"></span>
    
          <mat-icon class="app-icon">person</mat-icon>
          <div
            class="app-pr3 app-pl1 tw-font-bold tw-text-[var(--sed-black-80-color)]"
            >
            {{ session.user.firstName }}
          </div>
    
          <button
            mat-icon-button
            alt="New Messages"
            class="nopadding"
            routerLink="/communication-center"
            role="button"
            [attr.aria-label]="'View new Message/s' | translation: translationRequest"
            tabindex="0"
            >
            <mat-icon
              [matBadge]="commCenterService.unreadMessageCount()"
              class="app-icon"
              matBadgeColor="accent"
              >mail_outline</mat-icon
              >
            </button>
            @if (showHeaderIcons) {
              <div class="md:tw-block">
                @if (showSearch) {
                  <app-overlay
                    [origin]="searchOverlayOrigin"
                    #searchOverlay
                    [overlayClassName]=""
                    >
                    @if (searchOverlay.opened) {
                      <app-quick-search
                        [showTitle]="false"
                        class="overlay"
                      ></app-quick-search>
                    }
                  </app-overlay>
                  <button
                    [attr.aria-label]="'Search Popup' | translation: translationRequest"
                    mat-icon-button
                    cdkOverlayOrigin
                    #searchOverlayOrigin="cdkOverlayOrigin"
                    (click)="searchOverlay.open()"
                    >
                    <mat-icon class="app-icon">search</mat-icon>
                  </button>
                }
                @if (showWatchlist) {
                  <app-overlay [origin]="watchListOverlayOrigin" #watchListOverlay>
                    @if (watchListOverlay.opened) {
                      <app-watch-list
                        [overlay]="true"
                        class="overlay"
                        [translationRequest]="translationRequest"
                      ></app-watch-list>
                    }
                  </app-overlay>
                  <button
                    mat-icon-button
                    [attr.aria-label]="'Watch List Popup' | translation: translationRequest"
                    cdkOverlayOrigin
                    #watchListOverlayOrigin="cdkOverlayOrigin"
                    (click)="watchListOverlay.open()"
                    >
                    <mat-icon class="app-icon">star</mat-icon>
                  </button>
                }
                @if (showHistory) {
                  <app-overlay
                    [overlayClassName]="'history-overlay'"
                    [origin]="historyOverlayOrigin"
                    #historyOverlay
                    >
                    @if (historyOverlay.opened) {
                      <app-claim-history
                        [overlay]="true"
                        [translationRequest]="translationRequest"
                      ></app-claim-history>
                    }
                  </app-overlay>
                  <button
                    [attr.aria-label]="'History Popup' | translation: translationRequest"
                    mat-icon-button
                    cdkOverlayOrigin
                    #historyOverlayOrigin="cdkOverlayOrigin"
                    (click)="historyOverlay.open()"
                    >
                    <mat-icon class="app-icon">history</mat-icon>
                  </button>
                }
              </div>
            }
            @if (hasEulaAgreement === false) {
              <div class="md:tw-block">
                @if (!isPreference) {
                  <button
                    [attr.aria-label]="'Account settings' | translation: translationRequest"
                    mat-icon-button
                    role="link"
                    routerLink="PreferencesPage"
                    >
                    <mat-icon class="app-icon">settings</mat-icon>
                  </button>
                }
              </div>
            }
            @if (!hasEulaAgreement) {
              <div class="md:tw-block">
                <button
                  mat-button
                  class="app-icon"
                  class="logout"
                  [attr.aria-label]="'Logout and open the login page' | translation: translationRequest"
                  (click)="logOutEmulatedUser()"
                  >
                  <b>{{ 'Log out' | translation: translationRequest }}</b>
                </button>
              </div>
            }
          </mat-toolbar>
        </div>
    `,
    styles: [
        `
      .overlay h2 {
        padding-top: 20px;
      }

      .outlet {
        --max-width: 1280px;
      }
      .mat-mdc-toolbar.mat-mdc-primary {
        position: sticky;
        top: 0;
        z-index: 1;
        min-height: 64px;
      }

      .logo-image {
        padding-left: 50px;
        padding-right: 50px;
        padding-top: 20px;
      }

      @media (max-width: 760px) {
      }
      .example-spacer {
        flex: 1 1 auto;
      }

      .mat-mdc-toolbar {
        position: relative;
      }
      .overlay {
        width: 600px;
      }
      .header {
        background-color: #ffffff;
        color: #67707a;
        border-bottom: 1px solid #e0e0e0;
      }
      .header-xs {
        background-color: #ffffff;
      }

      .last-head-bar {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
      }
      .mat-toolbar-row,
      .mat-toolbar-single-row {
        min-height: 64px;
        height: auto !important;
      }

      @media only screen and (max-device-width: 480px) {
        .fixtoolbar {
          position: sticky;
          top: 0;
          z-index: 999999999;
          min-height: 64px;
        }
      }
      .preview-mode {
        z-index: 9999;
      }
    `,
    ],
    standalone: false
})
export class EmulateUserHeaderComponent implements OnInit {
  @Input() isSmall$: Observable<boolean>;
  @Input() isAuditor: boolean;
  @Input() showHeaderIcons: boolean;
  @Input() showSearch: boolean;
  @Input() showWatchlist: boolean;
  @Input() showHistory: boolean;
  @Input() hasEulaAgreement: any;
  @Input() isPreference: boolean;
  @Input() scrolled: boolean;
  @Input() translationRequest: TranslationRequest;

  @Output() logOutEmitter = new EventEmitter();
  @Input() drawer: MatDrawer;

  clientHeader: string;

  constructor(
    public session: Session,
    public commCenterService: CommCenterService
  ) {}

  async ngOnInit() {
    if (this.session.user) {
      this.clientHeader = this.session.clientHeader;
    }
  }

  toggleMenu() {
    if (this.drawer) {
      this.drawer.toggle();
    }
  }

  logOutEmulatedUser() {
    this.logOutEmitter.emit();
  }
}
